import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './SlidingPuzzle.css';

const SlidingPuzzle = () => {
  const [board, setBoard] = useState(() => initializeBoard());
  const [moves, setMoves] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  const [startTime, setStartTime] = useState(Date.now());

  function initializeBoard() {
    // Create solved board first
    const solved = Array.from({ length: 15 }, (_, i) => i + 1);
    solved.push(0); // Empty space
    
    // Shuffle the board
    const shuffled = [...solved];
    for (let i = 0; i < 1000; i++) {
      const emptyIndex = shuffled.indexOf(0);
      const possibleMoves = getPossibleMoves(emptyIndex);
      const randomMove = possibleMoves[Math.floor(Math.random() * possibleMoves.length)];
      [shuffled[emptyIndex], shuffled[randomMove]] = [shuffled[randomMove], shuffled[emptyIndex]];
    }
    
    return shuffled;
  }

  function getPossibleMoves(emptyIndex) {
    const moves = [];
    const row = Math.floor(emptyIndex / 4);
    const col = emptyIndex % 4;

    // Up
    if (row > 0) moves.push(emptyIndex - 4);
    // Down
    if (row < 3) moves.push(emptyIndex + 4);
    // Left
    if (col > 0) moves.push(emptyIndex - 1);
    // Right
    if (col < 3) moves.push(emptyIndex + 1);

    return moves;
  }

  const handleTileClick = (index) => {
    if (isComplete) return;

    const emptyIndex = board.indexOf(0);
    const possibleMoves = getPossibleMoves(emptyIndex);

    if (possibleMoves.includes(index)) {
      const newBoard = [...board];
      [newBoard[emptyIndex], newBoard[index]] = [newBoard[index], newBoard[emptyIndex]];
      setBoard(newBoard);
      setMoves(prev => prev + 1);

      // Check if puzzle is solved
      const solved = newBoard.every((tile, i) => {
        if (i === 15) return tile === 0; // Last position should be empty
        return tile === i + 1;
      });

      if (solved) {
        setIsComplete(true);
      }
    }
  };

  const resetGame = () => {
    setBoard(initializeBoard());
    setMoves(0);
    setIsComplete(false);
    setStartTime(Date.now());
  };

  const getElapsedTime = () => {
    if (isComplete) return 'Completed!';
    const elapsed = Math.floor((Date.now() - startTime) / 1000);
    const minutes = Math.floor(elapsed / 60);
    const seconds = elapsed % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  useEffect(() => {
    const timer = setInterval(() => {
      // Force re-render to update timer
      if (!isComplete) {
        // This will trigger a re-render
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [isComplete]);

  return (
    <div className="game-container">
      <div className="game-header">
        <h1 className="game-title-header">🧩 15-Puzzle</h1>
        <div className="game-instructions">
          Click on tiles adjacent to the empty space to move them. Arrange numbers 1-15 in order!
        </div>
      </div>

      <div className="game-board">
        <div className="score-display">
          {isComplete ? '🎉 Puzzle Solved!' : `Moves: ${moves} | Time: ${getElapsedTime()}`}
        </div>

        <div className="game-play-area">
          <div className="sliding-puzzle-board">
            {board.map((tile, index) => (
              <div
                key={index}
                className={`sliding-tile ${tile === 0 ? 'empty' : ''} ${
                  !getPossibleMoves(board.indexOf(0)).includes(index) && tile !== 0 ? 'unmovable' : ''
                }`}
                onClick={() => handleTileClick(index)}
              >
                {tile || ''}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="game-controls">
        <button className="btn btn-primary" onClick={resetGame}>
          Reset Game
        </button>
        <Link to="/" className="btn btn-secondary">
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default SlidingPuzzle;